import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { isMobile } from "react-device-detect";
import Spacebox from "../components/Spacebox";
import Grid from "../components/Grid";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";

const About = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    const navigate = useNavigate()

    const abouts = [
        {
            image: '/svgs/badge.svg',
            heading: 'Excellence',
            content: 'We strive for excellence in every interaction, ensuring our clients receive the highest quality service and funding solutions.'
        },
        {
            image: '/svgs/established-businesses.svg',
            heading: 'Innovation',
            content: `Our innovative approach combines technology and expertise to deliver modern funding solutions for today's businesses.`
        },
        {
            image: '/svgs/partnership.svg',
            heading: 'Partnership',
            content: `We build lasting partnerships with our clients, supporting their growth journey every step of the way.`
        },

    ]


    const reasons = [
        {
            image: 'fast-funding.svg',
            heading: 'Fast Funding',
            content: 'Get funded in as little as 24-48 hours with our streamlined process',
            items: [
                'Quick application process',
                'Minimal documentation required',
                'Same-day approval possible'
            ]
        },
        {
            image: 'secure.svg',
            heading: 'Secure & Trusted',
            content: 'Bank-level security with transparent terms and no hidden fees',
            items: [
                '256-bit encryption',
                'SOC 2 Type II compliant',
                'Transparent fee structure'
            ]
        },
        {
            image: 'growth.svg',
            heading: 'Growth Focused',
            content: 'Tailored funding solutions designed to accelerate your business growth',
            items: [
                'Flexible payment terms',
                'Scale funding as you grow',
                'Strategic growth planning'
            ]
        },
        {
            image: 'high-approval.svg',
            heading: 'High Approval Rate',
            content: 'AI-powered underwriting that looks beyond traditional credit scores',
            items: [
                'Multiple approval factors',
                'Alternative data analysis',
                'Holistic business evaluation'
            ]
        },
    ]

    return (
        <div className="about-page">
            <Header />
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '40px' : '60px', color: 'var(--primary)' }}>
                            About BrightStarr
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ textAlign: 'center', color: '#00000060', fontSize: isMobile ? '18px' : '20px' }}>
                            We're on a mission to revolutionize business funding by making it more <br />
                            accessible, transparent, and tailored to your unique needs.
                        </Typography>
                        <Spacebox padding="10px" />
                        <Grid grid={isMobile ? 1 : 3} gap="20px">
                            {abouts.map((a, i) => (
                                <div key={i} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                    <img src={a.image} alt={a.heading} style={{ width: '30px' }} />
                                    <Spacebox padding="10px" />
                                    <Typography>
                                        <b>
                                            {a.heading}
                                        </b>
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <span className="content" style={{ opacity: .6 }}>
                                        {a.content}
                                    </span>
                                </div>
                            ))}
                        </Grid>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Our Mission
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            At BrightStarr, we believe every business deserves the opportunity to grow and thrive. Our mission is to break down traditional funding barriers by providing innovative financial solutions that empower businesses to reach their full potential.
                        </Typography>
                        <Spacebox padding="10px" />
                        <Flexbox alignItems="center" justifyContent="center">
                            <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '15px 40px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                <Flexbox alignItems="center">
                                    <b style={{ fontSize: '18px' }}>Book A Consultation</b>
                                    <Spacebox padding="10px" />
                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                </Flexbox>
                            </Button>
                            <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '10px 20px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                <Flexbox alignItems="center">
                                    <b style={{ fontSize: '18px' }}>Book A Consultation</b>
                                    <Spacebox padding="10px" />
                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                </Flexbox>
                            </Button>
                        </Flexbox>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
            <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Flexbox alignItems="center" justifyContent="center">
                            <Flexbox alignItems="center" justifyContent="center" style={{ display: 'inline-block', padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '5px' }}>
                                <img src="/svgs/badge.svg" alt="badge" />
                            </Flexbox>
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Container>
                            <Typography variant="h4" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px' }}>
                                Why Choose Brightstarr ?
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                We combine cutting-edge technology with financial expertise to provide the <br />best funding solutions for your business
                            </Typography>
                            <Spacebox padding="20px" />
                            <Grid grid={isMobile ? 1 : 2} gap="20px">
                                {reasons.map((reason, index) => (
                                    <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                        <Flexbox alignItems="flex-start">
                                            <div className="hide-on-mid-and-small" style={{ width: 'fit-content', borderRadius: '5px', background: '#4A3FFF10', padding: '15px' }}>
                                                <img src={`/svgs/${reason.image}`} alt={reason.heading} style={{ width: '20px' }} />
                                            </div>
                                            <Spacebox className="hide-on-mid-and-small" padding="10px" />
                                            <div>
                                                <div className="hide-on-large-only margin-auto" style={{ width: 'fit-content', borderRadius: '5px', background: '#4A3FFF10', padding: '15px' }}>
                                                    <img src={`/svgs/${reason.image}`} alt={reason.heading} style={{ width: '20px' }} />
                                                </div>
                                                <Spacebox className="hide-on-large-only" padding="10px" />
                                                <Typography>
                                                    <b>
                                                        {reason.heading}
                                                    </b>
                                                </Typography>
                                                <Spacebox padding="10px" />
                                                <span style={{ opacity: .6 }}>
                                                    {reason.content}
                                                </span>
                                                <Spacebox padding="10px" />
                                                {reason.items.map((item, i) => (
                                                    <Flexbox key={i} style={{ marginBottom: '7px' }}>
                                                        <img src="/svgs/check.svg" alt="check" style={{ width: '14px' }} />
                                                        <Spacebox padding="10px" />
                                                        <small>{item}</small>
                                                    </Flexbox>
                                                ))}
                                            </div>
                                        </Flexbox>
                                    </div>
                                ))}
                            </Grid>
                            <Spacebox className="hide-in-mid-and-small" padding="20px" />
                            <Flexbox alignItems="center" justifyContent="center">
                                <Button className="" style={{ borderRadius: '5px', padding: '15px 40px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/apply')}>
                                    <Flexbox alignItems="center">
                                        <b style={{ fontSize: '18px' }}>Get Started Now</b>
                                        <Spacebox padding="10px" />
                                        <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                    </Flexbox>
                                </Button>
                            </Flexbox>
                            <Spacebox padding="40px" />
                            <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                                Ready to Get Started?
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                Take the first step towards securing the funding your business needs. <br />Our team is ready to help you explore your options.
                            </Typography>
                            <Spacebox padding="10px" />
                            <Flexbox alignItems="center" justifyContent="center">
                                <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '15px 40px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                    <Flexbox alignItems="center">
                                        <b style={{ fontSize: '18px' }}>Book A Consultation</b>
                                        <Spacebox padding="10px" />
                                        <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                    </Flexbox>
                                </Button>
                                <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '10px 20px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                    <Flexbox alignItems="center">
                                        <b style={{ fontSize: '18px' }}>Book A Consultation</b>
                                        <Spacebox padding="10px" />
                                        <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                    </Flexbox>
                                </Button>
                            </Flexbox>
                        </Container>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default About;